// Global 401 interceptor - auto logout on token expiry
import axios from 'axios';
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== '/login' && path !== '/register') {
        localStorage.removeItem('qtalk_token');
        localStorage.removeItem('qtalk_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const API_URL = 'https://qtalk.qualtechedge.in/api';
export const SOCKET_URL = 'https://qtalk.qualtechedge.in';

export const getAuthHeader = () => {
  const token = localStorage.getItem('qtalk_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const formatFileSize = (bytes) => {
  if (!bytes) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const getFileIcon = (mimeType) => {
  if (!mimeType) return { icon: 'file', color: '#6366f1', bg: '#ede9fe' };
  if (mimeType.startsWith('image/')) return { icon: 'image', color: '#0ea5e9', bg: '#e0f2fe' };
  if (mimeType.startsWith('video/')) return { icon: 'video', color: '#8b5cf6', bg: '#ede9fe' };
  if (mimeType.startsWith('audio/')) return { icon: 'audio', color: '#ec4899', bg: '#fce7f3' };
  if (mimeType.includes('pdf')) return { icon: 'pdf', color: '#ef4444', bg: '#fee2e2' };
  if (mimeType.includes('word') || mimeType.includes('document')) return { icon: 'doc', color: '#3b82f6', bg: '#dbeafe' };
  if (mimeType.includes('sheet') || mimeType.includes('excel')) return { icon: 'sheet', color: '#22c55e', bg: '#dcfce7' };
  if (mimeType.includes('presentation') || mimeType.includes('powerpoint')) return { icon: 'ppt', color: '#f97316', bg: '#ffedd5' };
  if (mimeType.includes('zip') || mimeType.includes('rar') || mimeType.includes('tar')) return { icon: 'zip', color: '#eab308', bg: '#fef9c3' };
  if (mimeType.includes('text') || mimeType.includes('sql') || mimeType.includes('json')) return { icon: 'txt', color: '#14b8a6', bg: '#ccfbf1' };
  return { icon: 'file', color: '#6366f1', bg: '#ede9fe' };
};
